<template>
  <div>
      <h2 class="mt-5">Partners</h2>

      <p>
          <a href="https://www.worldescortindex.com/" target="_blank" title="worldescortindex.com" rel="noopener nofollow" class="m-1">
              <img src="/img/234x60.jpg" alt="worldescortindex.com">
          </a>
          <a href="https://OpenAdultDirectory.com/escorts/" target="_blank" rel="nofollow" class="m-1">
              <img src="/img/oadlistedsite.jpg" alt="openadultdirectory.com">
          </a>
          <a href="https://www.holidaysexguide.com/" title="Holiday Sex Guide, The Escorts Directory." target="_blank" rel="nofollow" class="m-1">
              <img src='/img/hsg200x60.gif' alt="Click for Holiday Sex Guide, sex links to Nightlfe world wide." title="Holiday Sex Guide, The Escorts Directory.">
          </a>
          <a href="https://www.escortdude.com" target="_blank" title="Escortdude.com" class="m-1">
              <img src="/img/5de0dpnqsn.gif" alt="Escortdude.com">
          </a>

          <a href="https://www.citytourgirls.com" target="_blank" title="Citytourgirls" class="m-1">
              <img src="/img/hl7272urpy.gif" alt="Citytourgirls">
          </a>

          <a href="https://www.topescort.nl" target="_blank" title="Topescort.nl" class="m-1">
              <img src="/img/nmbszt1w06.gif" alt="Topescort.nl">
          </a>

          <a href="https://www.mistique.com/" target="_blank" title="Mistique" class="m-1">
              <img src="/img/bp8d8qjwbg.gif" alt="Mistique">
          </a>

          <a href="https://www.punterlink.co.uk/main/budapest-escorts" target="_blank" class="m-1">
              <img src="/img/1st1.gif" alt="Punterlink Budapest Escorts" title="Punterlink Budapest Escorts">
          </a>

          <a href="https://escortdirectory.tv" title="EscortDirectory.TV - Escorts World Wide">
              <img src="https://escortdirectory.tv/img/etv-200-100.gif" alt="EscortDirectory.TV - Escorts World Wide" title="EscortDirectory.TV - Escorts World Wide">
          </a>

          <a href="https://www.sexjobs.pl" target="_blank" title="Sexjobs.pl">
              <img style="width:300px;height:100px;" src="https://cdn.sexjobs.pl/static/bn/vdnxpuxclk.gif">
          </a>

          <a href="https://escortnews.eu" title="Escort Girls" target="_blank">
              <img src="https://static.escortnews.eu/234x60.gif" alt="Escort Girls">
          </a>

          <a href="https://www.escortnews.com" title="Escort Girls" target="_blank">
              <img src="https://static.escortnews.com/new/banners-2021/234x60.gif" alt="Escort Girls">
          </a>

          <a href="https://www.escortnews.co.nz" target="_blank" title="Escort New Zealand">
              <img style="width:234px;height:60px;" src="https://cdn.topescort.com/static/bn/iiulzg6grf.gif">
          </a>

          <a href="https://www.escortnews.com.au" target="_blank" title="Escort Australia">
              <img style="width:234px;height:60px;" src="https://cdn.topescort.com/static/bn/52ul7zywx6.gif">
          </a>

          <a href="https://www.callgirlsturkey.com" target="_blank" title="Call Girls Turkey">
              <img style="width:300px;height:100px;" src="https://cdn.callgirlsturkey.com/static/bn/c9l9dbqtje.gif">
          </a>

          <a href="https://www.escortgirls.be" target="_blank" title="Escort Belgium">
              <img style="width:300px;height:100px;" src="https://cdn.escortgirls.be/static/bn/3hfykm7ybt.gif">
          </a>

          <a href="https://www.sexjobs.it" target="_blank" title="Escort Italy">
              <img style="width:300px;height:100px;" src="https://cdn.sexjobs.it/static/bn/5knpd2wggs.gif">
          </a>

          <a href="https://www.sexguide.ro" target="_blank" title="Escort Romania">
              <img style="width:300px;height:100px;" src="https://cdn.sexguide.ro/static/bn/ef87a6crpw.gif">
          </a>

          <a href="https://www.sexjobs.gr" target="_blank" title="Sexjobs.gr">
              <img style="width:300px;height:100px;" src="https://cdn.sexjobs.gr/static/bn/ayr2uql5u1.gif">
          </a>

          <a href="https://www.topescort.com" target="_blank" title="Topescort">
              <img style="width:300px;height:100px;" src="https://cdn.topescort.com/static/bn/hxkb1kcdqa.gif">
          </a>

          <a href="https://www.privehuis.nl" target="_blank" title="Escort & Thuisontvangst">
              <img style="width:300px;height:100px;" src="https://cdn.privehuis.nl/static/bn/46lo7aerhc.gif">
          </a>

          <a href="https://www.sexmassage.nl" target="_blank" title="Sexmassage.nl">
              <img style="width:300px;height:100px;" src="https://cdn.escortspots.com/static/bn/36bsmmhfac.gif">
          </a>

          <a href="https://www.topescortnews.eu" target="_blank" title="Topescortnews.eu">
              <img style="width:300px;height:100px;" src="https://cdn.topescortnews.eu/static/bn/natoioni54.gif">
          </a>

          <a href="https://www.escortmykonos.com" target="_blank" title="Escortmykonos">
              <img style="width:300px;height:100px;" src="https://cdn.escortmykonos.com/static/bn/qnadvnhcvz.png">
          </a>

          <a href="https://www.seduce.nl" target="_blank" title="Escort Rotterdam">
              <img style="width:300px;height:100px;" src="https://cdn.topescort.com/static/bn/z3tb1yn711.gif">
          </a>

          <a href="https://www.tophookers.nl" target="_blank" title="Hoeren Amsterdam">
              <img style="width:300px;height:100px;" src="https://cdn.tophookers.nl/static/bn/9xnqjb12yz.gif">
          </a>

          <a href="https://www.escortspots.com" target="_blank" title="Escortspots.com">
              <img style="width:300px;height:100px;" src="https://cdn.escortspots.com/static/bn/nz6pnlkpbq.gif">
          </a>

          <a href="https://www.escorts.cz" target="_blank" title="Escorts.cz">
              <img style="width:300px;height:100px;" src="https://cdn.escorts.cz/static/bn/583l6ttyea.gif">
          </a>

      </p>
  </div>
</template>

<script>
export default {
    name: "PartnerComponent"
}
</script>
